import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AnnouncementBar.css';

const AnnouncementBar = () => {
  const mobileNumber = process.env.REACT_APP_PHONE_NUMBER || process.env.REACT_APP_WHATSAPP || '';
  const SecondNumber = process.env.REACT_APP_SECONDARY_NUMBER || process.env.REACT_APP_WHATSAPP || '';
  const contactPhrase = mobileNumber ? `on our mobile number +91 ${mobileNumber}  or +91 ${SecondNumber}` : 'on our mobile number (see Contact page)';
  const message = `Add your selected items to the cart and conveniently send your complete order via WhatsApp in one go — or feel free to contact us directly ${contactPhrase} to place your order with ease. `;
  const repeated = (message + " • ").repeat(4);

  return (
    <div className="announcement-bar" role="marquee" aria-live="polite">
      <div className="announcement-bar-inner">
        <div className="announcement-bar-track">
          <span className="announcement-bar-text">{repeated}</span>
          <span className="announcement-bar-text" aria-hidden="true">{repeated}</span>
        </div>
      </div>
      <Link to="/cart" className="announcement-bar-cta">View Cart</Link>
    </div>
  );
};

export default AnnouncementBar;
